AFRAME.registerPrimitive('a-rounded-plane', {
    defaultComponents: {
        'rounded-plane': {}
    },
    mappings: {
        width: 'rounded-plane.width',
        height: 'rounded-plane.height',
        radius: 'rounded-plane.radius',
        color: 'rounded-plane.color',
        opacity: 'rounded-plane.opacity',
        src: 'rounded-plane.src',
        'border-color': 'rounded-plane.borderColor',
        'border-opacity': 'rounded-plane.borderOpacity'
    }
});

AFRAME.registerComponent('rounded-plane', {
    schema: {
        width: { type: 'number', default: 1 },
        height: { type: 'number', default: 1 },
        radius: { type: 'number', default: 0.1 },
        color: { type: 'color', default: '#ffffff' },
        opacity: { type: 'number', default: 1.0, min: 0, max: 1 },
        src: { type: 'map' },
        borderColor: { type: 'color', default: '' }, // Empty string signals "use plane color"
        borderOpacity: { type: 'number', default: -1, min: 0, max: 1 } // -1 signals "use plane opacity"
    },

    init: function () {
        const data = this.data;

        // Determine border properties (default to plane's if not set)
        const effectiveBorderColor = data.borderColor === '' ? data.color : data.borderColor;
        const effectiveBorderOpacity = data.borderOpacity === -1 ? data.opacity : data.borderOpacity;

        // Create main plane mesh
        const planeShape = this.createRoundedShape(data.width, data.height, data.radius);
        const planeGeometry = new THREE.ShapeGeometry(planeShape);
        const planeMaterial = new THREE.MeshBasicMaterial({
            color: new THREE.Color(data.color),
            opacity: data.opacity,
            transparent: data.opacity < 1,
            side: THREE.DoubleSide
        });
        this.planeMaterial = planeMaterial;

        if (data.src) {
            this.updateTexture(data.src);
        }

        const planeMesh = new THREE.Mesh(planeGeometry, planeMaterial);

        // Create border as a LineLoop
        const borderShape = this.createRoundedShape(data.width, data.height, data.radius); // Same size as plane
        const borderPoints = borderShape.getPoints(64); // 64 segments for smooth curves
        const borderGeometry = new THREE.BufferGeometry().setFromPoints(borderPoints);
        const borderMaterial = new THREE.LineBasicMaterial({
            color: new THREE.Color(effectiveBorderColor),
            opacity: effectiveBorderOpacity,
            transparent: effectiveBorderOpacity < 1,
            linewidth: 1 // Fixed thin line
        });
        const borderLine = new THREE.LineLoop(borderGeometry, borderMaterial);
        borderLine.position.z = 0.001; // Slight offset to render in front

        // Add both to a group
        const group = new THREE.Group();
        group.add(planeMesh);
        group.add(borderLine);
        this.el.setObject3D('mesh', group);

        this.planeMesh = planeMesh;
        this.borderLine = borderLine;

        // Debug logs
        // console.log('Init - Plane color:', planeMaterial.color.getHexString(), 'Opacity:', planeMaterial.opacity, 'Transparent:', planeMaterial.transparent);
        // console.log('Init - Border color:', borderMaterial.color.getHexString(), 'Opacity:', borderMaterial.opacity, 'Transparent:', borderMaterial.transparent);
    },

    createRoundedShape: function(width, height, radius) {
        const shape = new THREE.Shape();
        const x = 0;  // Origin at lower-left
        const y = 0;
        radius = Math.min(radius, Math.min(width, height) / 2);

        shape.moveTo(x, y + radius);
        shape.lineTo(x, y + height - radius);
        shape.arc(radius, 0, radius, Math.PI, Math.PI / 2, true);
        shape.lineTo(x + width - radius, y + height);
        shape.arc(0, -radius, radius, Math.PI / 2, 0, true);
        shape.lineTo(x + width, y + radius);
        shape.arc(-radius, 0, radius, 0, -Math.PI / 2, true);
        shape.lineTo(x + radius, y);
        shape.arc(0, radius, radius, -Math.PI / 2, Math.PI, true);
        shape.closePath();

        return shape;
    },

    update: function (oldData) {
        const data = this.data;

        // Update geometry if dimensions change
        if (
            oldData.width !== data.width ||
            oldData.height !== data.height ||
            oldData.radius !== data.radius
        ) {
            // Update plane geometry
            const planeShape = this.createRoundedShape(data.width, data.height, data.radius);
            this.planeMesh.geometry.dispose();
            this.planeMesh.geometry = new THREE.ShapeGeometry(planeShape);

            // Update border geometry (same size as plane)
            const borderShape = this.createRoundedShape(data.width, data.height, data.radius);
            const borderPoints = borderShape.getPoints(64);
            this.borderLine.geometry.dispose();
            this.borderLine.geometry = new THREE.BufferGeometry().setFromPoints(borderPoints);
        }

        // Update plane material
        if (oldData.color !== data.color || oldData.opacity !== data.opacity) {
            this.planeMesh.material.color.set(data.color);
            this.planeMesh.material.opacity = data.opacity;
            this.planeMesh.material.transparent = data.opacity < 1;
            this.planeMesh.material.needsUpdate = true;
            // console.log('Update - Plane color:', this.planeMesh.material.color.getHexString(), 'Opacity:', this.planeMesh.material.opacity, 'Transparent:', this.planeMesh.material.transparent);
        }

        if (oldData.src !== data.src) {
            this.updateTexture(data.src);
        }

        // Update border material
        const effectiveBorderColor = data.borderColor === '' ? data.color : data.borderColor;
        const effectiveBorderOpacity = data.borderOpacity === -1 ? data.opacity : data.borderOpacity;
        if (
            oldData.borderColor !== data.borderColor ||
            oldData.borderOpacity !== data.borderOpacity ||
            oldData.color !== data.color || // If plane color changes and border uses it
            oldData.opacity !== data.opacity // If plane opacity changes and border uses it
        ) {
            this.borderLine.material.color.set(effectiveBorderColor);
            this.borderLine.material.opacity = effectiveBorderOpacity;
            this.borderLine.material.transparent = effectiveBorderOpacity < 1;
            this.borderLine.material.needsUpdate = true;
            // console.log('Update - Border color:', this.borderLine.material.color.getHexString(), 'Opacity:', this.borderLine.material.opacity, 'Transparent:', this.borderLine.material.transparent);
        }
    },

    remove: function () {
        this.planeMesh.geometry.dispose();
        this.planeMesh.material.dispose();
        this.borderLine.geometry.dispose();
        this.borderLine.material.dispose();
        this.el.removeObject3D('mesh');
    },

    updateTexture: function (src) {
        if (!src) {
            this.planeMaterial.map = null;
            this.planeMaterial.color.set(this.data.color);
            this.planeMaterial.needsUpdate = true;
            return;
        }

        const self = this;
        this.el.sceneEl.systems.material.loadTexture(src, { src: src }, function (texture) {
            // Apply texture
            texture.colorSpace = THREE.SRGBColorSpace;
            self.planeMaterial.map = texture;
            self.planeMaterial.color.set('#ffffff'); // Set color to white so texture is not tinted
            self.planeMaterial.needsUpdate = true;
        });
    }
});